import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconHeart(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.939 12.45a29.95 29.95 0 0 0 2.254-1.986C12.966 8.724 14 7.151 14 6.136c0-1.83-1.359-3.47-2.976-3.47-.868 0-1.497.352-1.983.959L8 4.926 6.959 3.625c-.486-.607-1.115-.959-1.983-.959C3.359 2.666 2 4.306 2 6.136c0 1.015 1.034 2.589 2.807 4.328a30.148 30.148 0 0 0 2.254 1.986c.347.278.665.522.939.725.274-.203.591-.447.939-.725zM7.008 1.898c.072.036.403.334.992.894a4.2 4.2 0 0 1 .992-.894c.523-.329 1.192-.565 2.032-.565 2.578 0 4.309 2.484 4.309 4.803 0 3.377-6.236 7.902-6.947 8.407a.662.662 0 0 1-.772 0C6.903 14.038.667 9.513.667 6.136c0-2.319 1.731-4.803 4.309-4.803.841 0 1.509.236 2.033.565z"
  }));
}
IconHeart.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconHeart.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconHeart as default };
